/* eslint-disable */
import React, {Component} from 'react'
import http from '../Interceptor/Interseptor'
import onClickOutside from 'react-onclickoutside'

class AutoComplete extends Component {
  constructor(props) {
    super(props)
    this.state = {
      text: '',
      title: '',
      timer: null,
      items: [],
      show: false
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      if (!this.props.value) {
        this.remove()
      }
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)

    const {value} = this.props
    if (value) {
      this.setSelected(value)
    }
  }

  handleClickOutside = (evt) => {
    // ..handling code goes here...
  }

  search = (api, term) => {
    if (term !== '') {
      return http
        .get(api, {
          params: {
            term,
            ...this.props.extraFilter
          }
        })
        .then((res) => {
          if (!res.data.error) {
            this.setState({
              items: res.data.object,
              show: this.state.text ? true : false
            })
          }
        })
        .catch(() => {})
    }
  }

  changeInput = (e) => {
    const {api} = this.props
    this.setState(
      {
        text: e.target.value
      },
      () => {
        if (this.state.text) {
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.search(api, this.state.text)
            clearTimeout(this.timer)
          }, 500)
        } else {
          this.setState({
            items: []
          })
        }
      }
    )
  }

  focusInput = () => {
    const {api} = this.props
    this.setState(
      {
        text: this.state.text
      },
      () => {
        if (this.state.text) {
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.search(api, this.state.text)
            clearTimeout(this.timer)
          }, 500)
        } else {
          this.setState({
            items: []
          })
        }
      }
    )
  }

  blurInput = () => {
    setTimeout(() => {
      this.setState({
        show: false
      })
    }, 400)
  }

  select = (item) => {
    if (item) {
      this.setState(
        {
          text: item[this.props.textField]
        },
        () => {
          this.emitValue(item[this.props.valueField])
          if (this.props.selected) {
            this.props.selected(item, 'selected')
          }
        }
      )
    }
  }

  remove = () => {
    this.setState(
      {
        text: ''
      },
      () => {
        this.emitValue('')
        if (this.props.selected) {
          this.props.selected({}, 'selected')
        }
      }
    )
  }

  emitValue = (value) => {
    this.props.setValue(value, 'setValue')
  }

  setSelected = (value) => {
    const {valueField, textField, api} = this.props
    return http
      .get(api, {
        params: {
          term: value,
          ...this.props.extraFilter
        }
      })
      .then((res) => {
        if (!res.data.error) {
          const findItem = res.data.object.find((item) => +item[valueField] === +value)
          if (findItem) {
            this.setState({
              text: findItem[textField]
            })
          }
        }
      })
      .catch(() => {})
  }

  render() {
    const {label, valueField, value, required, disabled} = this.props
    return (
      <div className="position-relative">
        <label>
          {label} :{required ? <span class="text-danger">*</span> : null}
        </label>
        <div class="input-group position-relative mb-3">
          {value ? (
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">
                {value}
              </span>
            </div>
          ) : null}

          <input
            type="text"
            class="form-control"
            aria-label="Username"
            aria-describedby="basic-addon1"
            value={this.state.text}
            onInput={this.changeInput}
            onFocus={this.focusInput}
            onBlur={this.blurInput}
            disabled={disabled}
          />
          {value && !disabled ? (
            <img
              onClick={() => this.remove()}
              src={require('../../image/close.svg')}
              style={{
                width: 20,
                position: 'absolute',
                top: '15%',
                left: 5,
                zIndex: 100,
                cursor: 'pointer',
                transform: 'translateY(20%)'
              }}
            />
          ) : null}
        </div>

        {/* <div class="input-group mb-3">
          <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon1">@</span>
          </div>
          <input
            className="form-control w-100"
            value={this.state.text}
            onInput={this.changeInput}
            onFocus={this.focusInput}
            onBlur={this.blurInput}
            type="text"
            disabled={disabled}
          />
        </div> */}

        {this.state.show ? (
          <div
            className="w-100 position-absolute"
            style={{
              maxHeight: '200px',
              top: '100%',
              overflowY: 'auto',
              zIndex: 3,
              background: '#f9f9f9'
            }}
          >
            {this.state.items.map((item) => (
              <div
                className="p-2 border-bottom cursor-pointer"
                style={{cursor: 'pointer'}}
                onClick={() => this.select(item)}
              >
                <div className="d-flex flex-row justify-content-between font-weight-bold">
                  <span>{item.title}</span>
                  <span className="badge badge-primary badge-small small">{item[valueField]}</span>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    )
  }
}

const clickOutsideConfig = {
  handleClickOutside: function(instance) {
    return instance.handleClickOutside
  }
}

export default onClickOutside(AutoComplete, clickOutsideConfig)
